import { render, staticRenderFns } from "./radioDepartment.vue?vue&type=template&id=d2b1f10c&scoped=true&"
import script from "./radioDepartment.vue?vue&type=script&lang=js&"
export * from "./radioDepartment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2b1f10c",
  null
  
)

export default component.exports